import React, { useContext } from 'react';

import { ServiceType } from ':types';

export const AuthContext = React.createContext({ auth: false });
interface IShowcaseTopbarSettings {
  profile: boolean;
  menu: boolean;
  notifications: boolean;
  component: {
    is_active: boolean;
    url: string;
    component_id: string;
  };
}

interface IShowcaseSettings {
  topbar: IShowcaseTopbarSettings;
  helpdesk: {
    url: string;
    template_id: string;
    is_consult_active: boolean;
    is_chatbot_active: boolean;
  };
}

interface IShowcaseInfoFooterLink {
  id: number;
  is_lan: boolean;
  name: string;
  type: ServiceType;
  url: string;
}
export interface IShowcaseInfo {
  name: string;
  alias: string;
  banner?:
    | {
        description: string;
      }
    | Record<string, never>;
  domain: string;
  settings: IShowcaseSettings;
  services: {
    footer: IShowcaseInfoFooterLink[];
  };
}

export const ShowcaseContext = React.createContext<IShowcaseInfo | null>(null);

export const useShowcaseContext = (): IShowcaseInfo | null =>
  useContext(ShowcaseContext);
